import { render, staticRenderFns } from "./chart-wrapper.vue?vue&type=template&id=66baf75c&scoped=true&"
import script from "./chart-wrapper.vue?vue&type=script&lang=ts&"
export * from "./chart-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./chart-wrapper.vue?vue&type=style&index=0&id=66baf75c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66baf75c",
  null
  
)

export default component.exports